import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-textt",
  "use": "icon-th-textt-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-textt\">\n<path d=\"M26 7V11C26 11.2652 25.8946 11.5196 25.7071 11.7071C25.5196 11.8946 25.2652 12 25 12C24.7348 12 24.4804 11.8946 24.2929 11.7071C24.1054 11.5196 24 11.2652 24 11V8H17V24H20C20.2652 24 20.5196 24.1054 20.7071 24.2929C20.8946 24.4804 21 24.7348 21 25C21 25.2652 20.8946 25.5196 20.7071 25.7071C20.5196 25.8946 20.2652 26 20 26H12C11.7348 26 11.4804 25.8946 11.2929 25.7071C11.1054 25.5196 11 25.2652 11 25C11 24.7348 11.1054 24.4804 11.2929 24.2929C11.4804 24.1054 11.7348 24 12 24H15V8H8V11C8 11.2652 7.89464 11.5196 7.70711 11.7071C7.51957 11.8946 7.26522 12 7 12C6.73478 12 6.48043 11.8946 6.29289 11.7071C6.10536 11.5196 6 11.2652 6 11V7C6 6.73478 6.10536 6.48043 6.29289 6.29289C6.48043 6.10536 6.73478 6 7 6H25C25.2652 6 25.5196 6.10536 25.7071 6.29289C25.8946 6.48043 26 6.73478 26 7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-textt.svg
// module id = Fgfp
// module chunks = 84